export default {"src":"/_next/static/media/mainlogo.83d02e0c.svg","height":106,"width":363,"blurWidth":0,"blurHeight":0};